import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import { getAllRows } from "../ReportElementHelper";
import SimpleAccordionContent from "../../common/SimpleAccordionContent";

class Bankruptcies extends Component {
  state = {
    rows: [],
    savedResultID: "",
    internalID: "",
  };

  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID ||
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
      this.loadData(nextProps);
    }
  }

  loadData = (props) => {
    const rows = [];
    let recCount = 0;
    if (props.reportData !== undefined) {
      const records = _.get(
        props.reportData,
        "personReport.compReportResponse[0].individual[0].bankruptcies[0].bankruptcy"
      );
      if (records) {
        _.forEach(records, (record, index) => {
          const recs = [];
          getAllRows(record, recs, props, _.get(record, "$.display"));
          if (recs.length > 0) {
            rows.push(
              <Table.Row key={`ban_row_${index}`}>
                <Table.Cell>
                  <Table>
                    <Table.Body>{recs}</Table.Body>
                  </Table>
                </Table.Cell>
              </Table.Row>
            );
          }
        });
        recCount = rows.length;
      } else {
        rows.push(
          <Table.Row key={`no_recs_row`}>
            <Table.Cell colSpan={2}>No Records found</Table.Cell>
          </Table.Row>
        );
      }
    }
    this.setState({ rows });
    props.updateItemCountBySection(props.sectionName, recCount);
  };

  render() {
    return (
      <SimpleAccordionContent
        {...this.props}
        name={"Bankruptcies"}
        rows={this.state.rows}
      />
    );
  }
}

export default Bankruptcies;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/Bankruptcies.js